<template>
    <div class="contact-fullpage contact">
        <div class="section">
            <section class="p_top_header">
                <div class="container">
                    <div class="row relative">
                        <div class="col-xs-12 col-sm-5">
                            <div class="circles_bg">
                                <div class="vertical_lines"></div>
                            </div>
                            <div class="relative m_b_40 p_r_60">
                                <h2>{{ $t('sections.contact.form.title') }}</h2>
                                <h1 class="c_orange">{{ $t('sections.contact.form.sub') }}</h1>
                                <i class="fa fa-paper-plane icon_send"></i>
                            </div>
                            <form @submit.prevent="submitForm" class="contact_form relative">
                                <label>
                                    <input type="text" v-model="record.name" :placeholder="$t('name')" required>
                                </label>
                                <label>
                                    <input type="num" v-model="record.phone" :placeholder="$t('phone')">
                                </label>
                                <label>
                                    <input type="email" v-model="record.email" :placeholder="$t('email')" required>
                                </label>
                                <label>
                                    <textarea type="text" v-model="record.message" :placeholder="$t('message')" rows="4" required></textarea>
                                </label>
                                <button type="submit" class="btn_send">
                                    <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                                </button>
                            </form>
                        </div>
                        <div class="col-xs-12 col-sm-offset-1 col-sm-6 col-md-offset-1 col-md-6">
                            <div class="circles_bg"></div>
                            <div class="trace">
                                <h2>{{ $t('sections.contact.for_further_info') }}</h2>
                            </div>
                            <div class="row infos_contact">
                                <div class="col-sm-12">
                                    <h3 class="c_orange">{{ $t('address') }}</h3>
                                    <address>
                                        <span>Avenida Rudolf Dafferner, 400 - Prédio Nova York, sala 319 <br> Alto da Boa Vista, Sorocaba/SP - Brasil - CEP: 18085-005</span>
                                    </address>
                                </div>
                                <div class="col-sm-12 col-md-5">
                                    <h3 class="c_orange">{{ $t('contacts') }}</h3>
                                    <span>+55 (15) 3227-5410</span>
                                    <a href="mailto:contato@guco.com.br">contato@guco.com.br</a>
                                </div>
                                <div class="col-sm-12 col-md-offset-1 col-md-6">
                                    <aside class="social_links m_t_30 show">
                                        <ul>
                                            <li>
                                                <a href="https://www.facebook.com/gucoweb/" target="_blank"><i class="fa fa-fw fa-facebook"></i></a>
                                            </li>
                                            <li>
                                                <a href="https://twitter.com/guco_web" target="_blank"><i class="fa fa-fw fa-twitter"></i></a>
                                            </li>
                                            <li>
                                                <a href="https://www.linkedin.com/company/2649725" target="_blank"><i class="fa fa-fw fa-linkedin"></i></a>
                                            </li>
                                            <li>
                                                <a href="https://www.behance.net/guco" target="_blank"><i class="fa fa-fw fa-behance"></i></a>
                                            </li>
                                        </ul>
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="section">
            <section class="map">
                <div class="container map">
                    <map :center.sync="center"
                         :zoom.sync="15"
                         :options="options"
                         class="map">
                        <marker
                            v-for="m in markers"
                            :position.sync="m.position"
                            :icon.sync="m.icon"
                            @g-click="center=m.position"
                        ></marker>
                    </map>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import jQuery from 'jquery'
    import _ from 'lodash'
    import { fullpage } from 'fullpage.js/dist/jquery.fullpage'
    import { load, Map, Marker } from 'vue-google-maps'
    import SweetAlert from 'sweetalert/lib/sweetalert'

    load('AIzaSyCSij4N0XBpyk815R5TFG-w4cSiX5tzKuc', '3.24')

    export default {
        name: 'Contact',
        data () {
            return {
                center: {
                    lat: -23.475278,
                    lng: -47.426684
                },
                markers: [
                    {
                        position: { lat: -23.475278, lng: -47.426684 },
                        icon: { url: './src/assets/images/pin-maps.png' }
                    },
                ],
                options: {
                    styles: [
                        {
                            "featureType": "all",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "saturation": 36
                                },
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 40
                                }
                            ]
                        },
                        {
                            "featureType": "all",
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "all",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 17
                                },
                                {
                                    "weight": 1.2
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 29
                                },
                                {
                                    "weight": 0.2
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 18
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 19
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#000000"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        }
                    ],
                    scrollwheel: false
                },
                record: {},
                meta: {
                    title: 'Contato',
                    description: 'Entre em contato e veja o que de melhor podemos oferecer a sua empresa!',
                    pageUrl: 'http://www.guco.com.br/contato',
                }
            }
        },
        head: {
            title () {
                return {
                    inner: this.meta.title
                }
            },
            meta () {
                return {
                    // Basic meta
                    name: {
                        'description' : this.meta.description,
                        'twitter:title': this.meta.title + ' | ' + this.meta.appName,
                        'twitter:description': this.meta.description,
                    },
                    // Google+ / Schema.org
                    itemprop: {
                        name: this.meta.title + ' | ' + this.meta.appName,
                        description: this.meta.description,
                    },
                    // Facebook / Open Graph
                    property: {
                        'og:url': this.meta.pageUrl,
                        'og:title': this.meta.title + ' | ' + this.meta.appName,
                        'og:description': this.meta.description,
                    }
                }
            },
            link () {
                return {
                    canonical: {
                        href: this.meta.pageUrl
                    },
                }
            }
        },
        components: {
            Map,
            Marker,
        },
        detached () {
            jQuery.fn.fullpage.destroy('all');
        },
        ready () {
            jQuery('.contact-fullpage').fullpage({
                anchors: ['Contatos', 'QG Secreto'],
                lockAnchors: true,
                css3: true,
                navigation: true,
                navigationPosition: 'right',
                navigationTooltips: ['Contatos', 'QG Secreto'],
                responsiveWidth: 993,
                responsiveHeight: 500
            });
        },
        computed: {
            emailBody () {
                let body = "Mensagem enviada pelo formulário de contato da Guco!\n\n"

                if(this.record.name)
                    body += "Nome: " + this.record.name + "\n\n"

                if(this.record.phone)
                    body += "Telefone: " + this.record.phone + "\n\n"

                if(this.record.email)
                    body += "E-mail: " + this.record.email + "\n\n"

                if(this.record.message)
                    body += "Mensagem: " + this.record.message + "\n\n"

                return body;
            }
        },
        methods: {
            submitForm() {
                return this.sendEmail();
            },
            sendEmail() {

                let data = {
                    api_user: 'gucosite',
                    api_key: 'JF*Has&7f98s',
                    to: 'contato@guco.com.br',
                    toname: 'Guco Agência Web',
                    subject: 'Contato pelo site da Guco',
                    text: this.emailBody,
                    from: this.record.email,
                }

                jQuery.ajax({
                    url: 'https://api.sendgrid.com/api/mail.send.json',
                    method: 'post',
                    data: data
                })
                .always(function() {
                    swal('Sucesso!', 'Em breve daremos um retorno', 'success');
                    this.record = {};
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Contact.vue?421a1bd0